'use strict';
module.exports = require('./Galleria.vue');